<template>
  <div class="grid-container full">
    <div class="data-container page-contents-8">
      <div class="left-data">
      <div class="left-data-2">
        <h2>125+</h2>
        <p>Clients</p>
      </div>
        <div class="left-data-1">
          <h2>Two million</h2>
          <p>Applications<br/>contextualised</p>
        </div>
      </div>
      <div class="right-data">
        <h2>61%</h2>
        <p>More disadvantaged candidates hired when organisations adopt the CRS</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeProductsCrsDataRow',
  props: {
  },
};
</script>

<style lang="scss" scoped>

  @import "~@/css/global.scss";

  .full {
    background-color: $dark-grey-background;
  }

  h2 {
    color: $green-highlight;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
  }

  .left-data p, .right-data p {
    color: #ffffff;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    text-transform: uppercase;
  }

  @media only screen and (max-width: 800px)  {
    .data-container {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
    }

    .right-data {
      justify-content: center;
      width: 100%;
      align-items: center;
    }

    .left-data {
      display: flex;
      flex-direction: column;
      justify-content: center;
      width: 100%;
      align-items: center;
      margin-bottom: 0;
    }

    .left-data-1, .left-data-2 {
      width: 100%;
      align-items: center;
    }

    h2 {
      font-size: 50px;
      line-height: 1;
      letter-spacing: normal;
      margin: 37px 0 7px 0;
      text-align: center;
    }

    .left-data p {
      font-size: 16px;
      line-height: 1.71;
      letter-spacing: 2px;
      margin: 7px 0 -15px 0;
      text-align: center;
    }

    .right-data p {
      font-size: 16px;
      line-height: 1.71;
      letter-spacing: 2px;
      margin: 7px 0 30px 0;
      text-align: center;
    }
  }

  @media only screen and (min-width: 800px) {
    .data-container {
      display: flex;
      justify-content: space-between;
    }

    .right-data {
      max-width: 40%;
    }

    .left-data {
      display: flex;
      justify-content: flex-start;
      width: 60%;
    }

    .left-data-2 {
      width: 40%;
    }

    h2 {
      font-size: 64px;
      line-height: 1;
      letter-spacing: normal;
      margin: 65px 0 10px 0;
    }

    .left-data p, .right-data p {
      font-size: 20px;
      line-height: 1.25;
      letter-spacing: 0.2em;
      margin: 20px 0 95px 0;
      padding: 0;
      text-transform: uppercase;
    }

    .top {
      margin-top: 75px;
    }

    .bottom {
      margin-bottom: 75px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/homeProducts/homeProductsCrs/components/HomeProductsCrsDataRow.vue